import { IconNames } from '@blueprintjs/icons';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { unblocklistTreatment } from 'api/treatmentAPI';
import { handleError } from 'services/Error';

const Title = 'Remove from Blocklist';

export const RemoveFromBlocklistDialog = ({
    isOpen,
    onClose,
    treatmentDetails = undefined,
    username,
    submitCallback,
}) => {
    const { treatmentId, payerId } = treatmentDetails ?? {};

    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            validationSchema={Yup.object({})}
            onSubmit={async (_, { resetForm }) => {
                try {
                    await unblocklistTreatment({
                        treatmentId,
                        payerId,
                        username,
                    });

                    submitCallback();

                    SuccessToast({ message: 'Treatment removed from blocklist successfully.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError(
                        'Unable to remove treatment from blocklist. Please try again.',
                        err,
                    );
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    headerIcon={IconNames.WARNING_SIGN}
                    isOpen={isOpen}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel={Title}
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <div className="margin__bottom--medium">
                            This will remove the treatment from the blocklist. This will not
                            remanage or reinitiate the treatment.
                        </div>
                    }
                />
            )}
        </Formik>
    );
};

RemoveFromBlocklistDialog.Title = Title;

RemoveFromBlocklistDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    treatmentDetails: PropTypes.shape({
        treatmentId: PropTypes.string.isRequired,
    }),
    username: PropTypes.string.isRequired,
    submitCallback: PropTypes.func.isRequired,
};
